module.exports = __webpack_public_path__ + "img/mercedes-eqc.9488b055.png";